// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1rrur","title":"ClientCherryInfo_title__nEknU","itemText":"ClientCherryInfo_itemText__1FZqV"};